import { render, staticRenderFns } from "./BrowseModeSave.vue?vue&type=template&id=4a668292&"
import script from "./BrowseModeSave.vue?vue&type=script&lang=ts&"
export * from "./BrowseModeSave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports